import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import EmployeeIdTextField from '../../user-details/profile-information/employee-id-textfield';
import WorkPhoneTextField from '../../user-details/profile-information/work-phone-textfield';
import ManagerEmailTextField from '../../user-details/profile-information/manager-email-textfield';
import PrimaryOrganizationSection from '../../user-details/profile-information/primary-organization-section';
import { UserFormValues } from '../user-schema';

import Box from '@mui/material/Box';
import { FormSectionHeader } from '../../../../shared/form-section-header';

interface StepEmployeeInformationProps {
  watch: UseFormWatch<UserFormValues>;
  setValue: UseFormSetValue<UserFormValues>;
  directoryRoles: string[];
}

export default function StepEmployeeInformation({
  directoryRoles,
  watch,
  setValue,
}: StepEmployeeInformationProps) {
  return (
    <Box gap={2}>
      <FormSectionHeader sx={{ mb: 2 }}>Employee Related</FormSectionHeader>
      <Box
        gap={2}
        mb={4}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 400px)',
        }}
      >
        <EmployeeIdTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditExternalIds.value
            )
          }
        />
        <WorkPhoneTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditPhoneNumbers.value
            )
          }
        />
        <ManagerEmailTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditRelationships.value
            )
          }
        />
      </Box>
      <FormSectionHeader sx={{ mb: 2 }}>Primary Organization</FormSectionHeader>
      <Box
        gap={2}
        mb={4}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 400px)',
        }}
      >
        <PrimaryOrganizationSection
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditOrganizations.value
            )
          }
        />
      </Box>
    </Box>
  );
}
